import React from 'react'

const PageTitle = (props) => {
    return (
        <div className="common-title-wrapper p-0 w-100">
            <div className="common-title mb-1 mt-3">{props.title}</div>
            <hr className="pt-1 rounded-pill mt-0 mb-3 ml-0 w-25" />
        </div>
    )
}

export default PageTitle